 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_COVER from '@/components/000_Cover'
 import A01_FM01 from '@/components/001_FM01'
 import A02_FM02 from '@/components/002_FM02'
 import A03_TITLEPAGE from '@/components/003_Titlepage'
 import A04_COPYRIGHT from '@/components/004_Copyright'
 import A05_DED from '@/components/005_Ded'
 import A06_CONTENTS from '@/components/006_Contents'
 import A07_FOREWORD from '@/components/007_Foreword'
 import A08_PREFACE from '@/components/008_Preface'
 import A09_ACK from '@/components/009_Ack'
 import A10_INTRODUCTION from '@/components/010_Introduction'
 import A11_CHAPTER01 from '@/components/011_Chapter01'
 import A12_CHAPTER02 from '@/components/012_Chapter02'
 import A13_CHAPTER03 from '@/components/013_Chapter03'
 import A14_CHAPTER04 from '@/components/014_Chapter04'
 import A15_CHAPTER05 from '@/components/015_Chapter05'
 import A16_CHAPTER06 from '@/components/016_Chapter06'
 import A17_CONCLUSION from '@/components/017_Conclusion'
 import A18_BIBLIOGRAPHY from '@/components/018_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/006_Contents",
 			"name" : "006_Contents",
 			"component" : A06_CONTENTS
 		},
 		{
 			"path" : "/007_Foreword",
 			"name" : "007_Foreword",
 			"component" : A07_FOREWORD
 		},
 		{
 			"path" : "/008_Preface",
 			"name" : "008_Preface",
 			"component" : A08_PREFACE
 		},
 		{
 			"path" : "/009_Ack",
 			"name" : "009_Ack",
 			"component" : A09_ACK
 		},
 		{
 			"path" : "/010_Introduction",
 			"name" : "010_Introduction",
 			"component" : A10_INTRODUCTION
 		},
 		{
 			"path" : "/011_Chapter01",
 			"name" : "011_Chapter01",
 			"component" : A11_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js